import { FC } from 'react';
import { Navigate } from 'react-router';

import { Loader } from 'components/UI/Loader';
import { useQuery } from 'hooks/useQuery';
import * as routes from 'router/routes';
import { useLoginWithAuthorizationCodeQuery } from 'store/diamApi';
import { REDIRECT_AFTER_LOGIN_KEY } from 'utils/constants';

export const AuthorizePage: FC = () => {
  const [code] = useQuery('code', 'error');
  const login = useLoginWithAuthorizationCodeQuery(code ?? '');

  // IAM-4754: Read the intended destination saved.
  const destination = sessionStorage.getItem(REDIRECT_AFTER_LOGIN_KEY) ?? routes.PROFILE;

  if (login.isLoading) {
    return <Loader />;
  }

  if (login.isError) {
    return <Navigate to={routes.LOGIN} replace />;
  }

  return <Navigate to={destination} replace />;
};
